import { Checkbox, Col, Divider, Form, Input, Row, Typography } from 'antd';
import InvoiceSerieNumberFields from '../fields/InvoiceSerieNumberFields';
import InvoiceTributesDefaultFields from '../fields/InvoiceTributesDefaultFields';
import { CompanyInvoiceSettingsForm } from '@/core/domain/invoice/settings/Settings.types';
import { FormInstance } from 'antd/es/form/Form';
import { FloatingFormItem, InputDecimal } from '@/components/_common';
import ContingencyIssueTypeSelect from '../fields/ContingencyIssueTypeSelect';
import StateCsrtSelect from '../fields/StateCsrtSelect';
import { useCompanyFormContext } from '../../CompaniesFormProvider';

interface Props {
  configNfe?: number;
  form: FormInstance<CompanyInvoiceSettingsForm>;
}

const CompanyInvoiceNFe: React.FC<Props> = ({ configNfe, form }: Props) => {
  const { useInternalInvoiceApiNfe, company } = useCompanyFormContext();
  const companyState = company?.companyAddress?.state;

  return (
    <>
      <Form.Item name={['nfe', 'id']} hidden>
        <Input />
      </Form.Item>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Typography.Title level={4}>Geral</Typography.Title>

          <Row gutter={[16, 16]}>
            {!useInternalInvoiceApiNfe && (
              <Col>
                <Form.Item
                  name={['nfe', 'automaticIbptCalculation']}
                  valuePropName="checked"
                >
                  <Checkbox>Cálcular IBPT automático</Checkbox>
                </Form.Item>
              </Col>
            )}

            <Col>
              <Form.Item name={['nfe', 'emailSending']} valuePropName="checked">
                <Checkbox>Enviando e-mail</Checkbox>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <FloatingFormItem
                label="Natureza da operação"
                name={['nfe', 'natureOfOperationDefault']}
              >
                <Input />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12}>
              <Form.Item
                name={['nfe', 'shouldNotDeductExemptIcmsDefault']}
                initialValue={false}
                valuePropName="checked"
              >
                <Checkbox>
                  ICMS desonerado não diminui no total da nota
                </Checkbox>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <FloatingFormItem
                label="Identificador do Código de Segurança do Responsável Técnico (CSRT)"
                name={['nfe', 'stateCsrtId']}
              >
                <StateCsrtSelect state={companyState} />
              </FloatingFormItem>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Typography.Title level={5}>IBPT Simplificado</Typography.Title>

          <Row gutter={[16, 16]}>
            <Col>
              <FloatingFormItem
                name={['nfe', 'generalIbptRate']}
                label="Aliquota IBPT simplificado"
              >
                <InputDecimal fractions={4} max={100} />
              </FloatingFormItem>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Typography.Title level={4}>Contingência</Typography.Title>

          <Row gutter={[16, 16]}>
            <Col span={24} md={12} xl={8}>
              <FloatingFormItem
                label="Tipo de emissão"
                name={['nfe', 'emissionType']}
              >
                <ContingencyIssueTypeSelect />
              </FloatingFormItem>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Typography.Title level={4}>Impressão</Typography.Title>

          <Row gutter={[16, 16]}>
            <Col>
              <Form.Item name={['nfe', 'fcpPrinting']} valuePropName="checked">
                <Checkbox>Impressão FCP</Checkbox>
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                name={['nfe', 'sharingPrinting']}
                valuePropName="checked"
              >
                <Checkbox>Partilha de impressão</Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Typography.Title level={4}>Tributos</Typography.Title>

          <InvoiceTributesDefaultFields invoiceType="nfe" form={form} />
        </Col>

        <Divider />

        <Col span={24}>
          <Typography.Title level={4}>Série e Numeração</Typography.Title>

          <Row gutter={[16, 16]}>
            <Col span={24}>
              <InvoiceSerieNumberFields configNfe={configNfe} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default CompanyInvoiceNFe;
